import { extension } from "mime-types";
import { triggerDownloadFromUrl } from "../Util";
import axios from "axios";
import { binaryDownloadOptions } from "./momangAxiosClient";

let axiosClientPublic;

function initPublic() {
  if (axiosClientPublic) return;
  axiosClientPublic = axios.create({ baseURL: process.env.REACT_APP_PROFILE_BACKEND_ENDPOINT });
}

export async function getMomangMetadata() {
  initPublic();
  const result = await axiosClientPublic.get("/metadata");
  return result.data;
}

export async function getProfileFromShare(shareSlug, ndaAccepted = undefined) {
  await initPublic();
  const response = await axiosClientPublic.get(`/smart-profiles/shares/${shareSlug}/profile`, {
    params: { ndaAccepted },
  });
  return response.data;
}

export async function sendFeedback(shareSlug, consultantName, feedbackObject) {
  await initPublic();
  const response = await axiosClientPublic.post(`/smart-profiles/feedback/${shareSlug}`, {
    consultantName,
    ...feedbackObject,
  });
  return response.data;
}

/**
 * Fetches a specific profile PDF from a share link and triggers the browser save file handling. The file is downloaded
 * straight from S3 with a pre-signed link. Requires the NDA to be accepted when the organization has one.
 */
export async function downloadProfilePdfFromShare(shareSlug, downloadAsFileName = "profile", ndaAccepted = undefined) {
  await initPublic();
  const { data } = await axiosClientPublic.get(`smart-profiles/shares/${shareSlug}/profile/pdf/link`, {
    params: { ndaAccepted },
  });
  const response = await fetch(data.url);
  if (!response.ok) throw new Error(`Could not download the PDF (${response.status}).`);
  const url = window.URL.createObjectURL(await response.blob());
  triggerDownloadFromUrl(url, `${downloadAsFileName}.pdf`);
}

/**
 * Fetches a profile attachment from a share link.
 */
export async function getProfileAttachmentFromShare(shareSlug, ndaAccepted = undefined) {
  await initPublic();
  const response = await axiosClientPublic.get(`smart-profiles/shares/${shareSlug}/profile/attachment`, {
    ...binaryDownloadOptions,
    params: { ndaAccepted },
  });
  const ext = extension(response.headers["content-type"]);
  const url = window.URL.createObjectURL(new Blob([response.data]));
  return [url, ext];
}

export async function getProfilePdfAttachmentFromShare(shareSlug, ndaAccepted = undefined) {
  const [url, ext] = await getProfileAttachmentFromShare(shareSlug, ndaAccepted);
  return ext === "pdf" ? url : null;
}

/**
 * Fetches a profile attachment from a share link and triggers the browser save file handling.
 */
export async function downloadProfileAttachmentFromShare(
  shareSlug,
  downloadAsFileName = "profile-attachment",
  ndaAccepted = undefined
) {
  const [url, ext] = await getProfileAttachmentFromShare(shareSlug, ndaAccepted);
  triggerDownloadFromUrl(url, `${downloadAsFileName}.${ext}`);
}
